import { render } from "./docsIndex.vue?vue&type=template&id=7bd530be"
import script from "./docsIndex.vue?vue&type=script&lang=js"
export * from "./docsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__